import ChevronRight from "@untitled-ui/icons-react/build/esm/ChevronRight";
import {
  Card,
  Col,
  Collapse,
  Divider,
  Dropdown,
  Row,
  Spin,
  Statistic,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import { SettingOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import cnt from "../../../services/definedConstant";
import "../../../assets/styles/Bond.css";
import MainLayout from "../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../components/layouts/enhancement/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../treasury.config";
import {
  AccountFacility,
  handleFlgStatus,
  handleInterBankActionButtons,
} from "../../../components/facilities/TreasuryFacility";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import { BOM } from "../../../services/definedMethod";

const { Panel } = Collapse;
const { Text, Title } = Typography;

const ViewInterBankPlacement = (props) => {
  const { userData } = props;
  const { session } = userData;
  const { state: selectedInterBankKey } = useLocation();
  const navigate = useNavigate();

  const [interBankPlacementDetails, setInterBankPlacementDetails] = useState(
    {}
  );
  const [isLoading, setIsLoading] = useState(false);

  const [menuProps, setMenuProps] = useState({ items: [] });

  useEffect(() => {
    getInterBankPlacementById(selectedInterBankKey);
  }, []);

  const getInterBankPlacementById = (params) => {
    const url = `${apiConfig.InterBankPlacement}/${params}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        setInterBankPlacementDetails(objDetail);
        console.log(objDetail);

        /**
         * ON CLICK ACTION MENU
         */
        setMenuProps({
          items: handleInterBankActionButtons(objDetail),
          onClick: (e) => {
            console.log(e);

            const item = handleInterBankActionButtons(objDetail).find(
              (element) => element.key === e.key
            );
            if (item) {
              switch (item?.label.toLowerCase()) {
                case "approve":
                  return activateInterBankPlacement();
                case "disable":
                  return disableInterBankPlacement();
                case "close":
                  return closeInterBankPlacement();

                default:
                  //ROUTE REDIRECTING ACTIONS
                  return navigate(item.route, {
                    state: {
                      // ...state,
                      accountNo: objDetail.accountNo,
                      actionLabel: item.label,
                      // branchId: temp.officeId,
                    },
                  });
              }
            }
          },
        });
      }
    });
  };

  // function formatAccountInfo(account) {
  //   if (!account) return "-";

  //   const name = account.name || "";
  //   const glCode = account.glCode || "";

  //   if (name && glCode) {
  //     return `${name} (${glCode})`;
  //   }

  //   return name || "-";
  // }

  const transformedData = [
    {
      section: "Product Information",
      items: [
        {
          name: "Product Code",
          value: interBankPlacementDetails.productCode || "--",
        },
        {
          name: "Product Name",
          value: interBankPlacementDetails.productName || "--",
        },

        {
          name: "Product Category",
          value: interBankPlacementDetails?.productCategory?.text || "--",
          isTag: true,
        },
        {
          name: "Product Currency",
          value: interBankPlacementDetails?.currencyCode ?? "--",
          isTag: true,
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Applicable Entities",
              isTagGroup: true,
              fields:
                interBankPlacementDetails?.applicableEntities &&
                interBankPlacementDetails?.applicableEntities.length > 0
                  ? interBankPlacementDetails?.applicableEntities.map(
                      (entity) => ({
                        value: entity?.name ?? "--",
                        isTag: true,
                      })
                    )
                  : [{ value: "--", isTag: true }],
            },
          ],
        },
        {
          name: "Accounting Classification",
          value:
            interBankPlacementDetails?.accountingClassification?.name ?? "--",
          isTag: true,
        },
        {
          name: "Custodian",
          value: interBankPlacementDetails?.custodian?.name ?? "--",
          isTag: true,
        },
        {
          name: "Placement Type",
          value: interBankPlacementDetails?.placementType?.name ?? "--",
          isTag: true,
        },
        {
          name: "Collateral Type",
          value: interBankPlacementDetails?.collateralType?.name ?? "--",
          isTag: true,
        },
        {
          name: "Collateral Volume",
          value: interBankPlacementDetails?.collateralVolume?.name ?? "-",
          type: "text",
        },
        {
          name: "Collateral Number",
          value: interBankPlacementDetails?.collateralNumber?.name ?? "--",
          type: "text",
        },
        {
          name: "Collateral Value",
          value:
            interBankPlacementDetails.collateralCurrency +
              interBankPlacementDetails.collateralValue ?? "-",
          type: "text",
        },
        {
          name: "Collateral Maturity Date",
          value: interBankPlacementDetails.collateralMaturityDate ?? "-",
          type: "text",
        },
        {
          name: "Collateral Reference",
          value: interBankPlacementDetails.collateralIdentifier ?? "-",
          type: "text",
        },
        {
          name: "Start Date",
          value:
            BOM.DateTime(interBankPlacementDetails.startDate, "only-date") ||
            "--",
          type: "text",
        },
        {
          name: "End Date",
          value:
            BOM.DateTime(interBankPlacementDetails.endDate, "only-date") ||
            "--",
          type: "text",
        },
      ],
    },
    {
      section: "Terms",
      items: [
        {
          name: "Minimum Tenor",
          value: `${interBankPlacementDetails.minTenor} Days` || "--",
          type: "text",
        },
        {
          name: "Maximum Tenor",
          value: `${interBankPlacementDetails.maxTenor} Days` || "--",
          type: "text",
        },
        {
          name: "Default Tenor",
          value: `${interBankPlacementDetails.defaultTenor} Days` || "--",
          type: "text",
        },
        {
          name: "Default Rate",
          value: `${interBankPlacementDetails.defaultRate} %` || "--",
          type: "text",
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Rollover Option",
              isTagGroup: true,
              fields: [
                {
                  value: interBankPlacementDetails.allowRollover ?? "-",
                  isTag: true,
                },
                {
                  value:
                    interBankPlacementDetails.autoRollover !== undefined
                      ? interBankPlacementDetails.autoRollover
                        ? "Auto Rollover"
                        : "Manual Rollover"
                      : "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Early Termination Allowed",
              isTagGroup: true,
              fields: [
                {
                  value: interBankPlacementDetails.allowEarlyTermination ?? "-",
                  isTag: true,
                },
                {
                  value:
                    interBankPlacementDetails.redemptionCharge !== undefined
                      ? interBankPlacementDetails.redemptionCharge.name
                      : "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Placement Fee",
              isTagGroup: true,
              fields: [
                {
                  value: interBankPlacementDetails.allowPlacementFee ?? "-",
                  isTag: true,
                },
                {
                  value:
                    interBankPlacementDetails.penaltyCharge !== undefined
                      ? interBankPlacementDetails.penaltyCharge.name
                      : "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      section: "Interest",
      items: [
        {
          name: "Interest Type",
          value: interBankPlacementDetails?.interestType?.text || "--",

          isTag: true,
        },
        {
          name: "Interest Rate Type",
          value: interBankPlacementDetails?.interestRateType?.text || "--",
          isTag: true,
        },
        {
          name: "Default Rate",
          value: `${interBankPlacementDetails.defaultRate} %` || "--",
        },
        {
          name: "Interest Calculation Basis",
          value:
            interBankPlacementDetails?.interestCalculationBasis?.text || "--",
          isTag: true,
        },
        {
          name: "Interest Posting Type",
          value: interBankPlacementDetails?.interestPostingType?.text || "--",
          isTag: true,
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Tax Group",
              isTagGroup: true,
              fields: [
                {
                  value: interBankPlacementDetails.allowTax ?? "-",
                  isTag: true,
                },
                {
                  value:
                    interBankPlacementDetails.taxGroup !== undefined
                      ? interBankPlacementDetails.taxGroup?.name
                      : "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
      ],
    },

    {
      section: "Accounting",
      items: [
        {
          isInlineGroup: true,
          group: [
            {
              name: "Placement Initiation",
              isTagGroup: true,
              fields: [
                {
                  value: formatAccountInfo(
                    interBankPlacementDetails?.investmentGL?.debitAccount
                  ),
                  isTag: true,
                },
                {
                  value: formatAccountInfo(
                    interBankPlacementDetails?.investmentGL?.creditAccount
                  ),
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Interest Accrual",
              isTagGroup: true,
              fields: [
                {
                  value: formatAccountInfo(
                    interBankPlacementDetails?.accruedInterestGL?.debitAccount
                  ),
                  isTag: true,
                },
                {
                  value: formatAccountInfo(
                    interBankPlacementDetails?.accruedInterestGL?.creditAccount
                  ),
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Interest Settlement (Maturity)",
              isTagGroup: true,
              fields: [
                {
                  value: formatAccountInfo(
                    interBankPlacementDetails?.settlementGL?.debitAccount
                  ),
                  isTag: true,
                },
                {
                  value: formatAccountInfo(
                    interBankPlacementDetails?.settlementGL?.creditAccount
                  ),
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Principal Redemption",
              isTagGroup: true,
              fields: [
                {
                  value: formatAccountInfo(
                    interBankPlacementDetails?.principalGL?.debitAccount
                  ),
                  isTag: true,
                },
                {
                  value: formatAccountInfo(
                    interBankPlacementDetails?.principalGL?.creditAccount
                  ),
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Interest GL Posting",
              isTagGroup: true,
              fields: [
                {
                  value: formatAccountInfo(
                    interBankPlacementDetails?.interestIncomeGL?.debitAccount
                  ),
                  isTag: true,
                },
                {
                  value: formatAccountInfo(
                    interBankPlacementDetails?.interestIncomeGL?.creditAccount
                  ),
                  isTag: true,
                },
              ],
            },
          ],
        },
      ],
    },

    {
      section: "CounterParty Settings",
      items: [
        {
          isInlineGroup: true,
          group: [
            {
              name: "Customer Type",
              isTagGroup: true,
              fields:
                interBankPlacementDetails?.counterpartyTypes &&
                interBankPlacementDetails?.counterpartyTypes.length > 0
                  ? interBankPlacementDetails?.counterpartyTypes.map(
                      (entity) => ({
                        value: entity?.name ?? "--",
                        isTag: true,
                      })
                    )
                  : [{ value: "--", isTag: true }],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "KYC Requirement",
              isTagGroup: true,
              fields:
                interBankPlacementDetails?.kycRequirements &&
                interBankPlacementDetails?.kycRequirements.length > 0
                  ? interBankPlacementDetails?.kycRequirements.map(
                      (entity) => ({
                        value: entity?.name ?? "--",
                        isTag: true,
                      })
                    )
                  : [{ value: "--", isTag: true }],
            },
          ],
        },
        {
          name: "Deal Confirmation",
          value: interBankPlacementDetails?.activateDealConfirmation ?? "-",
          isTag: true,
        },
        {
          name: "SWIFT / NIBSS Codes",
          value: interBankPlacementDetails?.allowSwiftCode ?? "-",
          isTag: true,
        },
        {
          name: "Real Time Gross Settlement",
          value: interBankPlacementDetails?.allowRTGS ?? "-",
          isTag: true,
        },
      ],
    },

    {
      section: "Compliance",
      items: [
        {
          isInlineGroup: true,
          group: [
            {
              name: "Central Bank Reports",
              isTagGroup: true,
              fields:
                interBankPlacementDetails?.centralBankReports &&
                interBankPlacementDetails?.centralBankReports.length > 0
                  ? interBankPlacementDetails?.centralBankReports.map(
                      (entity) => ({
                        value: entity?.name ?? "--",
                        isTag: true,
                      })
                    )
                  : [{ value: "--", isTag: true }],
            },
          ],
        },
        {
          name: "Risk Limit",
          value: interBankPlacementDetails?.riskLimit?.toLocaleString() ?? "--",
          isTag: true,
        },
        {
          name: "Mandatory AML Screening",
          value: interBankPlacementDetails.mandatoryAMLScreening ?? "-",

          isTag: true,
        },
      ],
    },
  ];

  function activateInterBankPlacement() {
    // console.log("activating...");
    // return;

    setIsLoading(true);
    const params = {
      command: "activate",
    };

    const url = `${apiConfig.InterBankPlacement}/${selectedInterBankKey}/modify-status?`;

    const body = {
      // dateFormat: "dd MMMM yyyy",
      // locale: "en",
      method: "POST",
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Product Activated succesfully");
        //STOP LOAD
        getInterBankPlacementById(selectedInterBankKey);
        setIsLoading(false);
      }
    });
  }
  function disableInterBankPlacement() {
    setIsLoading(true);
    const params = {
      command: "disable",
    };
    const url = `${apiConfig.InterBankPlacement}/${selectedInterBankKey}/modify-status?`;

    const body = {
      // dateFormat: "dd MMMM yyyy",
      // locale: "en",
      method: "POST",
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Product Disabled succesfully");
        //STOP LOAD
        getInterBankPlacementById(selectedInterBankKey);
        setIsLoading(false);
      }
    });
  }
  function closeInterBankPlacement() {
    setIsLoading(true);
    const params = {
      command: "close",
    };
    const url = `${apiConfig.InterBankPlacement}/${selectedInterBankKey}/modify-status?`;

    const body = {
      // dateFormat: "dd MMMM yyyy",
      // locale: "en",
      method: "POST",
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Product Closed succesfully");
        //STOP LOAD
        getInterBankPlacementById(selectedInterBankKey);

        setIsLoading(false);
      }
    });
  }

  const renderTag = (value, maxLength = 30) => {
    const displayValue = typeof value === "string" ? value : String(value);

    if (value === true) {
      return (
        <Tag
          style={{
            backgroundColor: "#ECFDF3",
            border: "1px solid #ABEFC6",
            borderRadius: "16px",
            padding: "2px 12px",
          }}
        >
          <Text
            style={{
              color: "#067647",
              fontWeight: 600,
            }}
          >
            Yes
          </Text>
        </Tag>
      );
    }

    if (value === false) {
      return (
        <Tag
          style={{
            backgroundColor: "#F9FAFB",
            border: "1px solid #EAECF0",
            borderRadius: "16px",
            padding: "2px 12px",
            textTransform: "capitalize",
          }}
        >
          <Text
            style={{
              color: "#344054",
              fontWeight: 600,
            }}
          >
            No
          </Text>
        </Tag>
      );
    }

    if (
      value === "-" ||
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return (
        <Text style={{ fontWeight: 500, color: "#6b7280" }}>
          {value || "-"}
        </Text>
      );
    }

    // Default tag for select fields with text truncation using BOM.SubstringFormat
    const shouldTruncate = displayValue.length > maxLength;
    const truncatedText = BOM.SubstringFormat(displayValue, maxLength);

    return (
      <Tooltip title={shouldTruncate ? displayValue : null} placement="top">
        <Tag
          style={{
            backgroundColor: "#FDF4FF",
            border: "1px solid #F6D0FE",
            borderRadius: "16px",
            padding: "2px 12px",
            maxWidth: "200px", // Set max width for tags
          }}
        >
          <Text
            style={{
              textTransform: "capitalize",
              color: "#9F1AB1",
              fontWeight: 600,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              display: "inline-block",
              maxWidth: "100%",
            }}
          >
            {truncatedText}
          </Text>
        </Tag>
      </Tooltip>
    );
  };

  function formatAccountInfo(account, maxLength = 40) {
    if (!account) return "-";

    const name = account.name || "";
    const glCode = account.glCode || "";

    let fullText = "";
    if (name && glCode) {
      fullText = `${name} (${glCode})`;
    } else {
      fullText = name || "-";
    }

    return fullText;
  }

  // const renderRow = (item, index, section) => {
  //   const isLastItem =
  //     index === (transformedData[section]?.items?.length || 0) - 1;

  //   const getDisplayValue = (val) => {
  //     if (val == null || val === "") return "-";
  //     if (typeof val === "object")
  //       return val.text || val.value || JSON.stringify(val);
  //     return val.toString();
  //   };

  //   if (item.isInlineGroup && Array.isArray(item.group)) {
  //     return item.group.map((fieldGroup, groupIndex) => (
  //       <div
  //         key={`inline-group-${section}-${index}-${groupIndex}`}
  //         style={{
  //           display: "flex",
  //           borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
  //         }}
  //       >
  //         <div
  //           style={{
  //             padding: "16px 24px",
  //             width: "50%",
  //             backgroundColor: "#f9f9f9",
  //             fontWeight: "500",
  //             borderRight: "1px solid #f0f0f0",
  //           }}
  //         >
  //           {fieldGroup.name}
  //         </div>
  //         <div
  //           style={{
  //             display: "flex",
  //             flexWrap: "wrap",
  //             gap: "8px",
  //             padding: "16px 24px",
  //             width: "50%",
  //             backgroundColor: "#fff",
  //           }}
  //         >
  //           {fieldGroup.fields.map((subField, subIndex) => {
  //             const displayValue = getDisplayValue(subField.value);
  //             const accountInfo =
  //               fieldGroup.name.includes("GL") ||
  //               fieldGroup.name.includes("Account")
  //                 ? formatAccountInfo(subField.value)
  //                 : displayValue;
  //             const truncatedAccountInfo = BOM.SubstringFormat(accountInfo, 50);

  //             return (
  //               <div
  //                 key={`${fieldGroup.name}-${subIndex}`}
  //                 style={{
  //                   display: "flex",
  //                   alignItems: "center",
  //                   fontWeight: 500,
  //                   maxWidth: "100%",
  //                 }}
  //               >
  //                 {subField.isTag ? (
  //                   renderTag(accountInfo)
  //                 ) : (
  //                   <Tooltip
  //                     title={
  //                       accountInfo && accountInfo.length > 50
  //                         ? accountInfo
  //                         : null
  //                     }
  //                     placement="top"
  //                   >
  //                     <span
  //                       style={{
  //                         overflow: "hidden",
  //                         textOverflow: "ellipsis",
  //                         whiteSpace: "nowrap",
  //                         maxWidth: "200px",
  //                         display: "inline-block",
  //                       }}
  //                     >
  //                       {truncatedAccountInfo}
  //                     </span>
  //                   </Tooltip>
  //                 )}
  //               </div>
  //             );
  //           })}
  //         </div>
  //       </div>
  //     ));
  //   }

  //   return (
  //     <div
  //       key={item.key || item.name}
  //       style={{
  //         display: "flex",
  //         borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
  //       }}
  //     >
  //       <div
  //         style={{
  //           padding: "16px 24px",
  //           width: "50%",
  //           backgroundColor: "#f9f9f9",
  //           fontWeight: "500",
  //           borderRight: "1px solid #f0f0f0",
  //         }}
  //       >
  //         {item.name}
  //       </div>
  //       <div
  //         style={{
  //           padding: "16px 24px",
  //           width: "50%",
  //           backgroundColor: "#fff",
  //           maxWidth: "50%",
  //         }}
  //       >
  //         {item.isTag ? (
  //           renderTag(getDisplayValue(item.value))
  //         ) : (
  //           <Tooltip
  //             title={
  //               getDisplayValue(item.value) &&
  //               getDisplayValue(item.value).length > 50
  //                 ? getDisplayValue(item.value)
  //                 : null
  //             }
  //             placement="top"
  //           >
  //             <Text
  //               style={{
  //                 textTransform: "capitalize",
  //                 fontWeight: 600,
  //                 overflow: "hidden",
  //                 textOverflow: "ellipsis",
  //                 whiteSpace: "nowrap",
  //                 display: "inline-block",
  //                 maxWidth: "100%",
  //               }}
  //             >
  //               {BOM.SubstringFormat(getDisplayValue(item.value), 50)}
  //             </Text>
  //           </Tooltip>
  //         )}
  //       </div>
  //     </div>
  //   );
  // };

  // Keep your existing getDisplayValue function as is:
  const getDisplayValue = (val) => {
    if (val == null || val === "") return "-";
    if (typeof val === "object")
      return val.text || val.value || JSON.stringify(val);
    return val.toString();
  };

  const renderRow = (item, index, section) => {
    const isLastItem =
      index === (transformedData[section]?.items?.length || 0) - 1;

    if (item.isInlineGroup && Array.isArray(item.group)) {
      return item.group.map((fieldGroup, groupIndex) => (
        <div
          key={`inline-group-${section}-${index}-${groupIndex}`}
          style={{
            display: "flex",
            borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
          }}
        >
          <div
            style={{
              padding: "16px 24px",
              width: "50%",
              backgroundColor: "#f9f9f9",
              fontWeight: "500",
              borderRight: "1px solid #f0f0f0",
            }}
          >
            {fieldGroup.name}
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "8px",
              padding: "16px 24px",
              width: "50%",
              backgroundColor: "#fff",
            }}
          >
            {fieldGroup.fields.map((subField, subIndex) => {
              // *** THE CRITICAL CHANGE IS HERE ***
              // Use getDisplayValue to ensure subField.displayValue is always a string
              const subFieldDisplayValue = getDisplayValue(subField.value);

              const truncatedSubFieldDisplayValue = BOM.SubstringFormat(
                subFieldDisplayValue,
                50
              );

              return (
                <div
                  key={`${fieldGroup.name}-${subIndex}`}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontWeight: 500,
                    maxWidth: "100%",
                  }}
                >
                  {subField.isTag ? (
                    renderTag(subFieldDisplayValue)
                  ) : (
                    <Tooltip
                      title={
                        subFieldDisplayValue && subFieldDisplayValue.length > 50
                          ? subFieldDisplayValue
                          : null
                      }
                      placement="top"
                    >
                      <span
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          maxWidth: "200px",
                          display: "inline-block",
                        }}
                      >
                        {truncatedSubFieldDisplayValue}
                      </span>
                    </Tooltip>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ));
    }

    const itemDisplayValue = getDisplayValue(item.value);

    return (
      <div
        key={item.key || item.name}
        style={{
          display: "flex",
          borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
        }}
      >
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#f9f9f9",
            fontWeight: "500",
            borderRight: "1px solid #f0f0f0",
          }}
        >
          {item.name}
        </div>
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#fff",
            maxWidth: "50%",
          }}
        >
          {item.isTag ? (
            renderTag(itemDisplayValue)
          ) : (
            <Tooltip
              title={
                itemDisplayValue && itemDisplayValue.length > 50
                  ? itemDisplayValue
                  : null
              }
              placement="top"
            >
              <Text
                style={{
                  textTransform: "capitalize",
                  fontWeight: 600,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  display: "inline-block",
                  maxWidth: "100%",
                }}
              >
                {BOM.SubstringFormat(itemDisplayValue, 50)}
              </Text>
            </Tooltip>
          )}
        </div>
      </div>
    );
  };
  return (
    <MainLayout pageItems={staticConfig.viewInterBankPlacementItems}>
      <TopContent
        pageTitle={labelConfig.interBankPlacement}
        createPageTitle={labelConfig.detailInterBankPlacement}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 20,
          }}
        >
          <div layout="vertical" style={{ paddingTop: 20, marginBottom: 50 }}>
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.generalInfo}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10 }} />
            <Row>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Dropdown.Button
                  menu={menuProps}
                  // menu={menuItems}
                  icon={<SettingOutlined />}
                  placement="topLeft"
                >
                  Actions
                </Dropdown.Button>
              </Col>

              {/* <Col span={12} style={{ padding: "0px 8px" }}>
                <Card
                  bordered={true}
                  bodyStyle={{
                    paddingTop: 12,
                    paddingBottom: 12,
                    // paddingLeft: 24,
                  }}
                  hoverable={true}
                  style={{ marginBottom: 24, backgroundColor: "#EAE7EC" }}
                >
                  <Row>
                    <Col span={12}>
                      <Statistic
                        title={"Product Name"}
                        value={
                          interBankPlacementDetails?.productName ??
                          "Product Name"
                        }
                        valueStyle={{
                          fontSize: "16px",
                        }}
                      />

                      <Statistic
                        title={"Product Code"}
                        value={
                          interBankPlacementDetails?.productCode ??
                          "321-233-977-128"
                        }
                        valueStyle={{
                          fontSize: "16px",
                        }}
                        formatter={(val) => val}
                      />
                    </Col>
                    <Col span={12}>
                      {interBankPlacementDetails?.status
                        ? handleFlgStatus(
                            interBankPlacementDetails?.status.text,
                            {
                              fontSize: 16,
                            },
                            false
                          )
                        : "-"}
                    </Col>
                  </Row>
                </Card>
              </Col> */}
            </Row>

            <AccountFacility
              status={interBankPlacementDetails?.status?.text}
              name={interBankPlacementDetails?.productName}
              id={interBankPlacementDetails?.productCode}
              isProduct={true}
            />

            <Row
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 20,
              }}
            >
              {transformedData.map((section, index) => (
                <Col>
                  <Collapse
                    className="custom-collapse"
                    // expandIconPosition="start"
                    expandIcon={<ChevronDown color="red" />}
                    style={{
                      backgroundColor: "transparent",
                      padding: 0,
                    }}
                  >
                    <Panel
                      key={index + 1}
                      header={
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: 500,
                          }}
                        >
                          {section.section}
                        </span>
                      }
                      style={{
                        borderRadius: "8px",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          border: "1px solid #f0f0f0",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                      >
                        {section.items.map((item, itemIndex) =>
                          renderRow(item, itemIndex, index)
                        )}
                      </div>
                    </Panel>
                  </Collapse>
                </Col>
              ))}
            </Row>
          </div>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewInterBankPlacement);
